// extracted by mini-css-extract-plugin
module.exports = {"zipButton":"style_zipButton__10fqH","active":"style_active__XsBKM","ready":"style_ready__1gyb-"};